module.exports = __webpack_public_path__ + "static/media/integral-icon-1.736f334c.png";